import { toast } from 'sonner';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

const mb = (bytes) => (bytes > 0 ? ` (~${Math.max(1, Math.round(bytes / 1048576))} MB)` : '');

/**
 * Ask the backend for a short-lived ZIP link, then hand it to the browser as one download.
 * `requestTicket` must return a fetch Response for the zip-ticket endpoint.
 */
export async function startZipDownload(requestTicket) {
  const toastId = toast.loading('Preparing your photos…');
  try {
    const res = await requestTicket();
    let data = {};
    try { data = await res.json(); } catch { /* non-JSON error */ }
    if (!res.ok) throw new Error(data.detail || `Download failed (error ${res.status})`);

    const link = document.createElement('a');
    link.href = `${API_BASE}${data.url}`;
    link.download = data.filename;
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast.success(`Downloading ${data.photo_count} photos as one ZIP${mb(data.total_bytes)}`, {
      id: toastId,
      description: 'Check your Downloads folder. Large galleries can take a minute.',
      duration: 8000,
    });
    return true;
  } catch (err) {
    toast.error("Couldn't download your photos", {
      id: toastId,
      description: err.message === 'Failed to fetch' ? 'Network error — please check your connection and try again.' : err.message,
      duration: 10000,
    });
    return false;
  }
}
